import { gql } from "@apollo/client"
import { BlockchainProduct, Slicer, getSliceSubdomain } from "."
import { decimalToHex } from "./decimalToHex"
import fetcher from "./fetcher"
import formatCartProducts from "./formatCartProducts"
import { client } from "./apollo-client"

export async function getStoreProducts(slicerId: number, chainId = 8453) {
  const hexId = decimalToHex(Number(slicerId))
  const sliceUrl = `https://${getSliceSubdomain(chainId)}slice.so`
  const tokensQuery = /* GraphQL */ `
      slicer(id: "${hexId}") {
        products (
          where: {
            isRemoved: false
          }
        ) {
          id
          prices {
            currency {
              id
            }
            price
            dynamicPricing
            externalAddress
          }
          isInfinite
          availableUnits
          maxUnitsPerBuyer
          extAddress
          extValue
          extRelativePrice
          extCheckSig
          extExecSig
        }
      }
    `

  const [{ data: slicer }, { data: subgraphData }]: [{ data: Slicer }, any] =
    await Promise.all([
      fetcher(`${sliceUrl}/api/slicer/${hexId}/products?fromSlicer=true`),
      client(chainId).query({
        query: gql`
        query {
          ${tokensQuery}
        }
      `,
        fetchPolicy: "no-cache"
      })
    ])
  const products = slicer.products

  const blockchainProducts: BlockchainProduct[] = subgraphData?.slicer?.products
  const cartProducts = formatCartProducts({
    blockchainProducts,
    products,
    slicer,
    slicerId,
    chainId
  })
  return cartProducts
}
